import { render, staticRenderFns } from "./AnimatedSvg.vue?vue&type=template&id=50c0cd81&scoped=true&"
import script from "./AnimatedSvg.vue?vue&type=script&lang=js&"
export * from "./AnimatedSvg.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedSvg.vue?vue&type=style&index=0&id=50c0cd81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c0cd81",
  null
  
)

export default component.exports